import { ALTERAR_REGISTROS_POR_PAGINA_PEDIDO } from '../types'

export default function alterarRegistrosPorPaginaPedido (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_PEDIDO,
    payload: valor
  }
}
